import { supabase } from "../../supabaseClient";

export const saveCashback = async (id = undefined, item) => {
  if (id) {
    return await supabase
      .from("Cashback")
      .update({ ...item })
      .match({ id });
  } else {
    return await supabase.from("Cashback").insert([{ ...item }]);
  }
};

export const removeCashback = async (item) => {
  return await supabase
    .from("Cashback")
    .update({ ...item, deleted_at: new Date() })
    .match({ id: item.id });
};
